/** @format */

import { TRoom } from '../@ducks/room/declarations';
import { NAME_PORTAL_CODE } from '../utils/gatsby/constants';
import { Axios } from '../utils/gatsby/createAxiosInstance';
import { utilitySetControllerTimeEnd } from '../utils/helpers/utilitySetControllerTimeEnd';

export const apiRoomDetail = async ({
  roomCode,
  locale,
  portalCode = NAME_PORTAL_CODE,
}: {
  roomCode: string;
  locale: string;
  portalCode: string | null;
}): Promise<TRoom | undefined> => {
  const controller = new AbortController();
  const signal = controller.signal;

  try {
    const URL = `/Beds/${portalCode}/${encodeURIComponent(roomCode.toUpperCase())}?language=${locale}`;
    const timeoutId = utilitySetControllerTimeEnd(controller);
    const response = await Axios.get(URL, { signal });
    if (response.status !== 200) throw new Error(URL);
    if (response) clearTimeout(timeoutId);
    return response.data;
  } catch (error) {
    console.error(error);
  }
};
